/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetParentalConsent } from '../../models/set-parental-consent';

export interface SetParentalConsent$Params {
  profileId: string;
      body?: SetParentalConsent
}

export function setParentalConsent(http: HttpClient, rootUrl: string, params: SetParentalConsent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setParentalConsent.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setParentalConsent.PATH = '/studentprofile/{profileId}/parentalconsent';
